export default __webpack_public_path__ + "static/media/envato.fb638570.svg";